import React from 'react';
import StatementMatch from '../../../../../activities/StatementMatch';

const activityContent = {
  type: 'statementMatch',
  intro1:
    'In this activity, practice turning unclear commands into clear <i>Do</i> statements.',
  intro2:
    'Drag the clear <i>Do</i> statement and drop it onto the unclear command it improves.',
  columnHeaders: ['Unclear Command', 'Clear <i>Do</i> Statement'],
  columns: {
    1: {
      name: 'Could you please sit down?',
      key: 1,
      items: [],
    },
    2: {
      name: 'It’s time for dinner. Wash your hands, then put out the plates, the cups, the napkins, and the forks.',
      key: 2,
      items: [],
    },
    3: {
      name: 'What’s your problem? I told you to get over here.',
      key: 3,
      items: [],
    },
    4: {
      name: 'Stop being lazy and get up.',
      key: 4,
      items: [],
    },
    5: {
      name: 'Would you please behave?',
      key: 5,
      items: [],
    },
    6: {
      name: 'Answers',
      items: [
        {
          id: '1',
          content: 'Please sit down.',
          key: 1,
        },
        {
          id: '2',
          content: 'It’s dinner time, please go wash your hands.',
          key: 2,
        },
        {
          id: '3',
          content: 'Please come here.',
          key: 3,
        },
        {
          id: '4',
          content: 'You need to get up off the couch now.',
          key: 4,
        },
        {
          id: '5',
          content: 'Sit quietly in this chair.',
          key: 5,
        },
      ],
    },
  },
};

const DoStatementsActivity = () => {
  return (
    <div className='activity-wrap'>
      <div className='routine activity-wrapper'>
        <StatementMatch content={activityContent} />
      </div>
    </div>
  );
};

export default DoStatementsActivity;
